import { ReactNode } from "react";

export const DEFAULT_VALUES = Object.freeze({
    br: <br />,
    p: (chunks: ReactNode) => <p>{chunks}</p>,
    strong: (chunks: ReactNode) => <strong>{chunks}</strong>,
    span: (chunks: ReactNode) => <span>{chunks}</span>
});
